import { render, staticRenderFns } from "./ESelecionarFranquiaModal.vue?vue&type=template&id=3389cab3"
import script from "./ESelecionarFranquiaModal.vue?vue&type=script&lang=js"
export * from "./ESelecionarFranquiaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports